angular.module( 'acme.view.application.groups.roles', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.groups.roles.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var groupsRoles = {
        name: 'application.groups.roles',
        url: '/:id/roles',
        views: {
          "subview-main": {
            controller: 'GroupsRolesController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/groups/roles/roles.tpl.html'
          }
        },
        data: {
          pageTitle: 'Group Roles',
          permissions: ['USER_GROUPS_UPDATE']
        },
        resolve: {
          GroupData: [ '$stateParams', 'ApiService', function($stateParams, ApiService) {
            return ApiService.groups.detail($stateParams.id);
          }]
        }
      };

    $stateProvider
      .state(groupsRoles);
});
